export const GET_RATE_LIST_REQUEST = "GET_RATE_LIST_REQUEST";
export const GET_RATE_LIST_SUCCESS = "GET_RATE_LIST_SUCCESS";
export const GET_RATE_LIST_FAILURE = "GET_RATE_LIST_FAILURE";
export const GET_RATE_LIST_RESET = "GET_RATE_LIST_RESET";
export const getRateListRequest = (payload) => ({
    type: GET_RATE_LIST_REQUEST,
    payload,
});
export const getRateListSuccess = (payload) => ({
    type: GET_RATE_LIST_SUCCESS,
    payload,
});
export const getRateListFailure = (payload) => ({
    type: GET_RATE_LIST_FAILURE,
    payload,
});
export const getRateListReset = () => ({
    type: GET_RATE_LIST_RESET,
});
